/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import teaserSloganStyle from "./teaserSloganStyle";
import Container from "../Container/Container";
import Grid from "@mui/material/Grid";
import backgroundTeaser from "../../assets/img/teaser/Legalbird_Teaser_Jobseite.jpg";
import Typography from "@mui/material/Typography";

type TeaserSloganProps = {
  slogan: string;
  backgroundImagePath?: string;
  height?: number;
  headingColor?: string;
};

const TeaserSlogan = ({ slogan, backgroundImagePath = backgroundTeaser, height = 564, headingColor = "primary.main" }: TeaserSloganProps) => {
  return (
    <Grid
      container
      alignItems={"center"}
      sx={{
        ...teaserSloganStyle.teaserSlogan,
        backgroundImage: 'url("' + backgroundImagePath + '")',
        height: height,
      }}
    >
      <Grid item xs={12} sx={teaserSloganStyle.sloganContainer}>
        <Container sectionPadding={false}>
          <Typography variant={"h1"} sx={{ ...teaserSloganStyle.slogan, color: headingColor }}>
            {slogan}
          </Typography>
        </Container>
      </Grid>
    </Grid>
  );
};

export default TeaserSlogan;
